import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { usePopularCityCategories } from "@/hooks/useLocations";

// Real, crawlable internal links to the clean /doctors/{city} style pages —
// those pages already exist (canonical URL + sitemap entry, ListingsV2.tsx)
// but nothing on the site actually links to them, so Google has no strong
// internal-link signal to prioritize crawling/ranking them. Only shows
// combos the backend already confirmed have >=3 real listings (same bar the
// pages themselves use to avoid a noindex).
const PopularCityLinks = () => {
  const { data: combos, isLoading } = usePopularCityCategories(12);

  if (isLoading || !combos || combos.length === 0) return null;

  return (
    <section className="py-12 sm:py-16 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-xl sm:text-2xl font-bold mb-2">Popular Searches Near You</h2>
          <p className="text-muted-foreground text-sm max-w-xl mx-auto">
            Browse verified healthcare providers by city
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-2.5">
          {combos.map((c) => (
            <Link
              key={`${c.type_code}-${c.city_name}`}
              to={c.path}
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-pill bg-card border border-border/60 text-xs sm:text-sm font-medium text-foreground/80 shadow-sm hover:shadow-md hover:border-primary/30 hover:text-primary transition-all"
            >
              <MapPin className="w-3.5 h-3.5 text-primary/70" />
              {c.category_label} in {c.city_name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularCityLinks;
